import { IconChecklist, IconSparkles } from '@tabler/icons-react';
import { BRIEF } from './tasks';
import { useT } from '@hana/i18n';
import './i18n';
import s from './tasksDock.module.css';

// Bảng phải của Mint-Tasks-1920 (Tóm tắt đầu ngày + gợi ý chọn việc). Dữ liệu mẫu của board.

export function TasksDock({ showBrief, onHideBrief }: { showBrief: boolean; onHideBrief: () => void }) {
  const t = useT();
  return (
    <div className={s.dock} aria-label={t('tasks.detail')}>
      {showBrief && (
        <section className={s.brief} aria-label={t('tasks.briefTitle')}>
          <div className={s.hd}>
            <IconSparkles size={16} stroke={1.9} aria-hidden="true" />
            <b>{t('tasks.briefTitle')}</b>
            <span>Ask HANA · 08:00</span>
            <button type="button" className={s.x} aria-label={t('tasks.briefHide')} onClick={onHideBrief}>×</button>
          </div>
          <div className={s.tx}>{BRIEF}</div>
        </section>
      )}
      <div className={s.none}>
        <span className={s.ic}><IconChecklist size={24} stroke={1.8} aria-hidden="true" /></span>
        {t('tasks.pickOne')}
      </div>
    </div>
  );
}
